<div class="content-card p-6">
  <h3 class="text-lg font-semibold text-gray-900 mb-4">
    {{ isEditMode ? 'Editar Módulo' : 'Novo Módulo' }}
  </h3>

  <form [formGroup]="moduleForm" (ngSubmit)="onSave()" class="space-y-4">
    <div>
      <label
        for="module-content-type"
        class="mb-1 block text-sm font-medium text-gray-700"
      >
        Tipo de Conteúdo *
      </label>
      <select
        id="module-content-type"
        formControlName="contentType"
        [disabled]="isEditMode"
        class="form-field-control disabled:cursor-not-allowed disabled:opacity-50"
      >
        @for (option of contentTypeOptions; track option.value) {
        <option [value]="option.value">{{ option.label }}</option>
        }
      </select>
      @if (isEditMode) {
      <p class="mt-1 text-xs text-blue-800">
        O tipo de conteúdo não pode ser alterado após a criação do módulo.
      </p>
      }
    </div>

    <div>
      <label
        for="module-name"
        class="mb-1 block text-sm font-medium text-gray-700"
      >
        Nome do Módulo *
      </label>
      <input
        type="text"
        id="module-name"
        formControlName="name"
        class="form-field-control placeholder-gray-500"
        [class.border-red-500]="isFieldInvalid('name')"
        placeholder="Digite o nome do módulo"
      />
      @if (isFieldInvalid('name')) {
      <p class="mt-1 text-sm text-red-600">{{ getFieldError('name') }}</p>
      }
    </div>

    <div>
      <label
        for="module-description"
        class="mb-1 block text-sm font-medium text-gray-700"
      >
        Descrição *
      </label>
      <textarea
        id="module-description"
        formControlName="description"
        rows="3"
        class="form-field-textarea placeholder-gray-500"
        [class.border-red-500]="isFieldInvalid('description')"
        placeholder="Digite a descrição do módulo"
      ></textarea>
      @if (isFieldInvalid('description')) {
      <p class="mt-1 text-sm text-red-600">
        {{ getFieldError('description') }}
      </p>
      }
    </div>

    <div
      class="form-actions flex items-center justify-end gap-3 border-t border-gray-200 pt-4"
    >
      <button type="button" class="btn-secondary" (click)="onCancel()">
        Cancelar
      </button>
      <button type="submit" class="btn-primary" [disabled]="moduleForm.invalid">
        {{ isEditMode ? 'Salvar Alterações' : 'Criar Módulo' }}
      </button>
    </div>
  </form>
</div>
